"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M23.429.437a1.597 1.597 0 0 0-2.241.045L14 8.192l-2.38-2.35a1.597 1.597 0 0 0-2.24 0 1.555 1.555 0 0 0 0 2.217l3.521 3.483a1.594 1.594 0 0 0 2.264-.023l8.308-8.865A1.555 1.555 0 0 0 23.43.437Zm-4.461.61a3.916 3.916 0 0 0-1.213-.19H9.918A3.918 3.918 0 0 0 6 4.774v7.836a3.918 3.918 0 0 0 3.918 3.919h7.837a3.918 3.918 0 0 0 3.919-3.919V6l-1.96 2.09v4.521a1.96 1.96 0 0 1-1.959 1.96H9.918a1.96 1.96 0 0 1-1.959-1.96V6.776a2.52 2.52 0 0 1 0-.184V4.775a1.96 1.96 0 0 1 1.96-1.96h7.4l1.649-1.767ZM5 8H4a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4h-2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h1V8Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};